import { createContext, useContext } from 'react';

import { RowContextProps } from './types';

export const GridRowContext = createContext<RowContextProps<any>>({ row: {}, index: 0 });

export const useGridRowContext = <T extends Record<string, any>>() =>
  useContext(GridRowContext) as RowContextProps<T>;
